import { useState } from "react";
import { CalendarDays, Moon, Sun } from "lucide-react";
import { Stepper } from "@/components/Stepper";
import { mediaUrl } from "@/lib/api";

export function Hero({ content, onSearch }) {
  const [mode, setMode] = useState("dia");
  const [guests, setGuests] = useState(2);
  return (
    <section id="inicio" data-testid="hero-section" className="relative min-h-[100svh] flex items-end overflow-hidden grain">
      {content.hero_video ? (
        <video src={mediaUrl(content.hero_video)} autoPlay muted loop playsInline poster={mediaUrl(content.hero_image)}
          className="absolute inset-0 h-full w-full object-cover" />
      ) : (
        <img src={mediaUrl(content.hero_image)} alt="Rachel Lodge" className="absolute inset-0 h-full w-full object-cover" />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-[#1F2421]/85 via-[#1F2421]/30 to-[#1F2421]/20" />
      <div className="relative w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-10 sm:pb-16 pt-28">
        <p className="eyebrow !text-[#E5DCCB] fade-up">Valle Alegre · Quintero · Región de Valparaíso</p>
        <h1 data-testid="hero-title" className="mt-4 text-white text-5xl sm:text-6xl lg:text-7xl font-light tracking-tight leading-[1.02] max-w-3xl fade-up delay-1">
          {content.hero_title}
        </h1>
        <p className="mt-5 text-[#F3EDE2] text-base md:text-lg max-w-xl fade-up delay-2" data-testid="hero-subtitle">
          {content.hero_subtitle}
        </p>
        <div className="mt-8 sm:mt-10 fade-up delay-3 bg-[#FAF7F2]/95 backdrop-blur-xl rounded-3xl p-3 sm:p-4 shadow-2xl max-w-3xl flex flex-col sm:flex-row gap-3 sm:items-center"
          data-testid="hero-search">
          <div className="flex rounded-full bg-[#F3EDE2] p-1">
            {[["dia", "Por el día", Sun], ["noche", "Alojamiento", Moon]].map(([k, l, Icon]) => (
              <button key={k} type="button" onClick={() => setMode(k)} data-testid={`hero-mode-${k}`}
                className={`flex-1 sm:flex-none flex items-center justify-center gap-2 rounded-full px-4 py-2.5 text-sm font-semibold transition-colors ${mode === k ? "bg-[#5E6B52] text-white" : "text-foreground hover:bg-white"}`}>
                <Icon className="h-4 w-4" /> {l}
              </button>
            ))}
          </div>
          <div className="flex items-center justify-between sm:justify-start gap-3 px-2">
            <span className="text-sm text-muted-foreground">Personas</span>
            <Stepper value={guests} onChange={setGuests} min={1} max={35} testid="hero-guests" />
          </div>
          <button type="button" onClick={() => onSearch({ mode, guests })} data-testid="hero-check-availability-btn"
            className="sm:ml-auto flex items-center justify-center gap-2 rounded-full bg-[#C86D51] text-white px-6 py-3.5 font-semibold transition-colors hover:bg-[#B25C42]">
            <CalendarDays className="h-4 w-4" /> Ver disponibilidad
          </button>
        </div>
      </div>
    </section>
  );
}
